import React, { useState } from 'react';
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import MainPopup from '../popup-containers/MainPopup';
import HowEthosflowasBorn from './HowEthosflowasBorn';
import Usecasepopup from './Usecasepopup';
import Questionairepopup from './Questionairepopup';
import icon1 from './p-3.png';
import icon2 from './Picture8.png';
import icon3 from './Picture10.png';
import icon4 from './icons8.png';
import icon5 from './icons9.png';

const WhyEthosflo = () => {
  const [Popup, setPopup] = useState(false);
  const openPopup = () => setPopup(true);
  const closePopup = () => setPopup(false);

  const [Popup1, setPopup1] = useState(false);
  const openPopup1 = () => setPopup1(true);
  const closePopup1 = () => setPopup1(false);

  const [Popup2, setPopup2] = useState(false);
  const openPopup2 = () => setPopup2(true);
  const closePopup2 = () => setPopup2(false);

  const features = [
    {
      icon: icon1,
      title: 'Strategic Advantage',
      desc: 'Go beyond compliance to gain business edge',
      bg: '#344854',
    },
    {
      icon: icon2,
      title: 'Expert-Driven',
      desc: 'Methodology and Assessments by ESG experts with rich industry experience',
      bg: '#344854',
    },
    {
      icon: icon3,
      title: 'Cost-Effective',
      desc: 'Affordable even for SMEs',
      bg: '#344854',
    },
    {
      icon: icon4,
      title: 'Simple and concise questionnaire',
      desc: 'Easy-to-understand questionnaire with dedicated account managers for handholding',
      bg: '#2F4858',
    },
    {
      icon: icon5,
      title: 'Customized improvement plan',
      desc: 'Customized corrective actions provided with assessment report',
      bg: '#2F4858',
    },
  ];

  return (
    <section
    id="whyethosflo"
    className="bg-[#0D2B36] text-white scroll-mt-16 py-16 px-6 sm:px-8 lg:px-16 flex items-center"
  >
    <div className="max-w-7xl mx-auto w-full flex flex-col space-y-12">
        <h2 className="text-3xl text-center md:text-4xl font-bold font-avenir">
          Why Ethosflo?
        </h2>

        {/*mobile/tablet */}
        <div className="block lg:hidden">
          <img
            src={require('./whyd.png')}
            alt="Why Ethosflo Mobile"
            className="w-full h-auto"
          />
        </div>

        {/* lg+ */}
        <div className="flex justify-center">
        <div className="hidden lg:flex flex-col justify-center lg:ml-64 space-y-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row md:items-start md:space-x-6"
            >
              <div
                className="flex-shrink-0 flex items-center justify-center rounded-lg shadow hover:scale-105 transition"
                style={{
                  backgroundColor: feature.bg,
                  width: '60px',
                  height: '60px',
                }}
              >
                <img src={feature.icon} alt={`${feature.title} Icon`} className="w-6 h-6" />
              </div>
              <div className="mt-2 md:mt-0">
                <h3 className="text-xl font-semibold">{feature.title}</h3>
                <p className="text-gray-300">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
        </div>

        {/* ✅ Bottom Text & Buttons */}
        <div className="text-center">
          <p className="text-gray-300 text-justify leading-relaxed text-xl mt-6">
            Organizations face growing ESG expectations not only internally but across their value chains.
            Ethosflo offers a smart, outsourced solution to assess ESG maturity of business partners without
            burdening internal teams. The platform is expert-driven, cost-effective, and tailored even for SMEs,
            ensuring readiness and compliance amid rising global regulations.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 mt-6">
            <button
              className="text-lg px-4 py-2 bg-[#0A988B] hover:bg-teal-400 text-white font-semibold rounded transition duration-300"
              onClick={openPopup}
            >
              How Ethosflo was Born
            </button>

            <button
              className="text-lg px-4 py-2 bg-[#0A988B] hover:bg-teal-400 text-white font-semibold rounded transition duration-300"
              onClick={openPopup1}
            >
              Use Case
            </button>

            <button
              className="text-lg px-4 py-2 bg-[#0A988B] hover:bg-teal-400 text-white font-semibold rounded transition duration-300"
              onClick={openPopup2}
            >
              How we make the questionnaire simple
            </button>
          </div>
        </div>

        {/* ✅ Popups */}
        <MainPopup popUpOpen={Popup} setpopUpOpen={setPopup} widthAdjustment={true} bgcolor={true} loginPopups={true}>
          <PopUpScreenTitle
            title="How Ethosflo was Born"
            setpopUpOpen={closePopup}
            hederDetails={true}
            titleColorstatus={true}
          />
          <HowEthosflowasBorn />
        </MainPopup>

        <MainPopup popUpOpen={Popup1} setpopUpOpen={setPopup1} bgcolor={true} widthAdjustment={true} loginPopups={true}>
          <PopUpScreenTitle
            title="Use Case"
            setpopUpOpen={closePopup1}
            hederDetails={true}
            titleColorstatus={true}
          />
          <Usecasepopup />
        </MainPopup>

        <MainPopup popUpOpen={Popup2} setpopUpOpen={setPopup2} bgcolor={true} widthAdjustment={true} loginPopups={true}>
          <PopUpScreenTitle
            title="How we make the  questionnaire simple "
            setpopUpOpen={closePopup2}
            hederDetails={true}
            titleColorstatus={true}
          />
          <Questionairepopup />
        </MainPopup>
      </div>
    </section>
  );
};

export default WhyEthosflo;
